import axios from 'axios'

export const requestQuotation = (order) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/order/quotation-request', order)
      .then((response) => {
        if (response.data.error) {
          reject(response.data)
        } else {
          resolve(response.data)
        }
      })
      .catch((error) => reject())
  })
}
